// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__CEMhQ","modal":"Modal_modal__M5+Ia","modalIn":"Modal_modalIn__do7Jc","body":"Modal_body__Q4oaL","close":"Modal_close__VInZp"};